import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../utils/http.js';
import {
    TAG_ADMIN_TICKET,
    TAG_CONTACT,
    TAG_CONTACT_DUPLICATES,
    TAG_CONTACT_MISC,
    TAG_LEAD,
    TAG_LIST_ADMIN_TICKETS,
    TAG_LIST_CONTACTS,
    TAG_LIST_LEADS,
    TAG_LIST_MEETINGS,
    TAG_LIST_ORGANIZATIONS,
    TAG_LIST_PA_CHATS,
    TAG_LIST_PROJECTS,
    TAG_LIST_ROLES,
    TAG_LIST_USER_TICKETS,
    TAG_LIST_USERS,
    TAG_MEETING,
    TAG_NOTIFICATIONS,
    TAG_ORGANIZATION,
    TAG_PROJECT,
    TAG_ROLE,
    TAG_USER_TICKET
} from './tags.js';

export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQuery,
    endpoints: () => ({}),
    tagTypes: [
        TAG_LIST_CONTACTS,
        TAG_CONTACT,
        TAG_CONTACT_DUPLICATES,
        TAG_CONTACT_MISC,
        TAG_LIST_MEETINGS,
        TAG_MEETING,
        TAG_LIST_USERS,
        TAG_LIST_ROLES,
        TAG_ROLE,
        TAG_LIST_USER_TICKETS,
        TAG_USER_TICKET,
        TAG_LIST_ADMIN_TICKETS,
        TAG_ADMIN_TICKET,
        TAG_NOTIFICATIONS,
        TAG_LIST_ORGANIZATIONS,
        TAG_ORGANIZATION,
        TAG_LIST_PROJECTS,
        TAG_PROJECT,
        TAG_LIST_LEADS,
        TAG_LEAD,
        TAG_LIST_PA_CHATS
    ]
});
